import _ from "lodash";
import GpxGeoJson from "./GpxGeoJson";
import PreUndoData from "./PreUndoData";

export default class ReinstateWorkspaceData extends PreUndoData {
    gpx: GpxGeoJson
    loadedTrackGpxUrl: string|null
    loadedTrackOwnedByCurrentUser: boolean|null
    loadedTrackIsPublic: boolean|null
    routerPath: string
    constructor(gpx: GpxGeoJson, loadedTrackGpxUrl: string|null, loadedTrackOwnedByCurrentUser: boolean|null, loadedTrackIsPublic: boolean|null, routerPath: string) {
        super()
        this.gpx = _.cloneDeep(gpx)
        this.loadedTrackGpxUrl = loadedTrackGpxUrl
        this.loadedTrackOwnedByCurrentUser = loadedTrackOwnedByCurrentUser
        this.loadedTrackIsPublic = loadedTrackIsPublic
        this.routerPath = routerPath
    }
}